__turbopack_context__.v({
  "entityFade": "LeftNavAdmin-module__IEaxUq__entityFade",
  "leftNavAdmin": "LeftNavAdmin-module__IEaxUq__leftNavAdmin",
});
